import { BaseFieldMaterialRenderer } from "./base-field-material-renderer";
import { Value } from "common/components/types";
import { asString } from "common/components/component-helpers";
import { GlideFunctionalRenderer } from "common/components/uis";

export const PhoneFieldMaterialRenderer: GlideFunctionalRenderer = p => {
    const convertIn = (input: Value): string => {
        return asString(input);
    };

    return <BaseFieldMaterialRenderer {...p} dataType="phone" convertIn={convertIn} />;
};
